import { Stack, Typography } from '@mui/material'
import { formatTime } from '@operations/utils/format-date'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

interface Props {
  date?: string | null
  isForDashboard?: boolean
}
export const StoppageDate = observer(({ date, isForDashboard }: Props) => {
  if (!date) return <></>

  return (
    <Stack>
      <Typography variant={isForDashboard ? 'body2' : 'subtitle2'}>
        {dayjs(date).format('l')}
      </Typography>
      <Typography
        variant={isForDashboard ? 'subtitle2' : 'body2'}
        color={isForDashboard ? undefined : 'secondary'}
      >
        {formatTime(date)}
      </Typography>
    </Stack>
  )
})
